import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75m0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.5 12.75h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.5 15.75c-.19 0-.38-.07-.53-.22l-3-3a.754.754 0 0 1 0-1.06l3-3c.29-.29.77-.29 1.06 0s.29.77 0 1.06L9.56 12l2.47 2.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"
    }, null, -1)
  ]))]))
}
export default { render: render }